<template></template>
<script>
    export default {
        name: "tidio-chat-widget",
        mounted() {
            this.boot();
        },
        data() {
            return {
                bootingInterval: null,
                booted: false,
                ready: false,
            }
        },
        computed: {
            config() {
                return ab.config.liveChat.platforms.filter((platform) => platform.name === 'Tidio')[0].config;
            },
            enabled() {
                return ab.config.liveChat.enabled && ab.config.liveChat.selectedPlatform === 'Tidio';
            },
            fileId() {
                return this.config.fileId;
            }
        },
        watch: {
            enabled(enabled) {
                if (enabled)
                    this.onEnabled();
                else
                    this.onDisabled();
            },
            fileId(fileId) {
                if (fileId) {
                    this.onFileIdParsed();
                } else {
                    this.onFileIdRemoved();
                }
            }
        },
        methods: {
            boot() {
                // 0. Guard
                if (this.booted || !this.fileId || !this.enabled)
                    return;

                // 1. Insert tidio script
                (function (d, s, id, fileId) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = `//code.tidio.co/${fileId}.js`;
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'tidio-live-chat-src', this.fileId));

                // 2. Listen to tidio events
                if (window.tidioChatApi) {
                    window.tidioChatApi.on("ready", this.onReady);
                    window.tidioChatApi.on("open", this.onOpen);
                    window.tidioChatApi.on("close", this.onClose);
                } else {
                    document.addEventListener("tidioChat-ready", this.onReady);
                    document.addEventListener("tidioChat-open", this.onOpen);
                    document.addEventListener("tidioChat-close", this.onClose);
                }

                // 3. Monitor booting
                let bootingTimeElapsed = 0
                if (this.bootingInterval) {
                  this.$store.commit('tidioChatBootingTimeElapsed', 0)
                  clearInterval(this.bootingInterval)
                }
                this.bootingInterval = setInterval(() => {
                  bootingTimeElapsed++
                  this.$store.commit('tidioChatBootingTimeElapsed', bootingTimeElapsed)
                  // 10sec
                  if (this.ready) {
                    clearInterval(this.bootingInterval)
                  } else if (bootingTimeElapsed === 10) {
                    this.booted = false
                    clearInterval(this.bootingInterval)
                    this.$store.commit("updateTidioChatBooting", false);
                  }
                }, 1000)

                this.$store.commit("updateTidioChatBooting", true);
                this.booted = true;
            },

            // Tidio API Events Handlers
            onReady() {
                this.ready = true;
                this.$store.commit("updateTidioChatBooting", false);

                // 1. Override Widget Style
                this.overrideInitialStyle();

                // 2. Hide the widget if tidio disabled
                if (!this.enabled || !this.config.fileId) {
                    this.hide();
                }

                // 3. Default to a closed chat
                tidioChatApi.close();
            },
            onOpen() {
                this.overrideOpenStyle();
            },
            onClose() {
                this.overrideInitialStyle();
            },

            // UI Events Handlers
            onEnabled() {
                if (!this.fileId)
                    return;
                this.show();
            },
            onDisabled() {
                this.hide();
            },
            onFileIdParsed() {
                this.show();
            },
            onFileIdRemoved() {
                this.hide();
            },

            // Widget Style Overriders
            overrideOpenStyle() {
                document.getElementById('tidio-chat-iframe')
                && (document.getElementById('tidio-chat-iframe').style.zIndex = '1039');
            },
            overrideInitialStyle() {
                document.getElementById('tidio-chat-iframe')
                && (document.getElementById('tidio-chat-iframe').style.zIndex = '1039');
            },

            // Tidio Api Methods Wrappers
            show() {
                if (this.booted) {
                    tidioChatApi.display(true);
                    tidioChatApi.close();
                    this.overrideInitialStyle();
                } else {
                    this.boot();
                }
            },
            hide() {
                if (!this.ready)
                    return;
                tidioChatApi.display(false);
            }
        }
    }
</script>

<style lang="scss">
    #tidio-chat-iframe {
        bottom: 1.8rem !important;
        @media only screen and (max-width: 600px) {
            bottom: 3rem !important;
        }
    }
</style>
